import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFarfetchComponent } from './simple-icons-farfetch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFarfetchComponent ],
    exports:      [ SimpleIconsFarfetchComponent ],
    bootstrap:    []
})
export class SimpleIconsFarfetchModule {}
